import { render } from "./ButtonWithIconContacts.vue?vue&type=template&id=2963f71e&scoped=true"
import script from "./ButtonWithIconContacts.vue?vue&type=script&lang=js"
export * from "./ButtonWithIconContacts.vue?vue&type=script&lang=js"

import "./ButtonWithIconContacts.vue?vue&type=style&index=0&id=2963f71e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2963f71e"]])

export default __exports__